import {
    TaskStatus as TaskStatusEnum,
    isTaskTerminatingStatus,
} from "@common/types/task";
import {
    TaskTodoIcon,
    TaskInProgressIcon,
    TaskDoneIcon,
    TaskBlockedIcon,
    TaskCancelledIcon,
} from "@icons/taskStatuses";

export function isTerminatingStatus(status: TaskStatusEnum): boolean {
    return isTaskTerminatingStatus(status);
}

export const TASK_STATUS_CONFIG: Record<
    TaskStatusEnum,
    {
        Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
        tooltip: string;
    }
> = {
    [TaskStatusEnum.TODO]: {
        Icon: TaskTodoIcon,
        tooltip: "To do",
    },
    [TaskStatusEnum.BLOCKED]: {
        Icon: TaskBlockedIcon,
        tooltip: "Blocked",
    },
    [TaskStatusEnum.IN_PROGRESS]: {
        Icon: TaskInProgressIcon,
        tooltip: "In progress",
    },
    [TaskStatusEnum.DONE]: {
        Icon: TaskDoneIcon,
        tooltip: "Done",
    },
    [TaskStatusEnum.CANCELLED]: {
        Icon: TaskCancelledIcon,
        tooltip: "Canceled",
    },
};
